import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import type * as React from 'react';

const styles = {
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
  },
  hidden: {
    visibility: 'hidden',
  },
  faded: {
    width: '100%',
    height: '100%',
    opacity: 0.2,
  },
  center: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 5,
  },
};

interface LoadingContainerProps {
  children?: React.ReactNode;
  loading?: boolean;
  showChildrenInBackground?: boolean;
  heading?: string;
  text?: string;
}

function LoadingContainer({
  children = null,
  loading = false,
  showChildrenInBackground = false,
  heading,
  text,
}: LoadingContainerProps) {
  if (loading) {
    return (
      <Box sx={styles.container}>
        <Box sx={styles.center}>
          {heading && <Typography variant="h5">{heading}</Typography>}
          <CircularProgress />
          {text && <Typography variant="body1">{text}</Typography>}
        </Box>
        <Box sx={showChildrenInBackground ? styles.faded : styles.hidden}>{children}</Box>
      </Box>
    );
  }
  // Fragment is needed for typesystem to convert ReactNode -> ReactElement

  return <>{children}</>;
}

export default LoadingContainer;
